module.exports = __webpack_public_path__ + "img/ema.4e08cf12.jpg";